import { Component, OnInit } from '@angular/core';
import {KursanciService} from "../services/kursanci.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-kursant-new',
  templateUrl: './kursant-new.component.html',
  styleUrls: ['./kursant-new.component.scss']
})
export class KursantNewComponent implements OnInit {

  grupaId: string;

  constructor(private kursanciService: KursanciService, route: ActivatedRoute) {

      this.grupaId = route.snapshot.queryParams['grupaId'];
  }

  ngOnInit() {
  }

    dodaj(formKursant) {
        this.kursanciService.dodajKursantaDoGrupy(this.grupaId, formKursant.value)
            .subscribe(
                () => {
                    alert("Kursant dodany do grupy. Dodać następnego kursanta?");
                    formKursant.reset();
                },
                err => alert(`Błąd. Nie udało się dodać kursanta. ${err}`)
            );
    }

    zapisz(formKursant) {
        this.kursanciService.dodajKursanta(formKursant.value)
            .subscribe(
                () => {
                    alert("Kursant zapisany. Dodać następnego kursanta?");
                    formKursant.reset();
                },
                err => alert(`Błąd. Nie udało się dodać kursanta. ${err}`)
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/kursant-new/kursant-new.component.ts